import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { Star, Quote } from "lucide-react";

const PORTRAITS = [
  "https://customer-assets.emergentagent.com/job_smile-transformation-10/artifacts/4tgvv0f3_WhatsApp%20Image%202026-05-25%20at%208.55.59%20PM.jpeg",
  "https://customer-assets.emergentagent.com/job_smile-transformation-10/artifacts/ghvf6dkp_WhatsApp%20Image%202026-05-25%20at%208.47.41%20PM.jpeg",
  null,
];

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[#F9F8F6] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <Reveal className="lg:col-span-7">
            <p className="overline mb-6">— {t.testimonials.overline}</p>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A]">
              {t.testimonials.title}{" "}
              <span className="italic text-[#D4AF37]">
                {t.testimonials.title_accent}
              </span>
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {t.testimonials.list.map((tst, i) => (
            <motion.article
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -4 }}
              className="relative bg-white border border-[#E5E5E5] rounded-3xl p-8 md:p-10 flex flex-col"
            >
              <Quote
                size={28}
                strokeWidth={1.2}
                className="text-[#D4AF37] mb-6"
              />
              <p className="font-display text-lg md:text-xl text-[#1A1A1A] leading-snug font-light mb-8">
                “{tst.text}”
              </p>
              <div className="mt-auto flex items-center gap-4 pt-6 border-t border-[#E5E5E5]">
                {PORTRAITS[i % PORTRAITS.length] ? (
                  <img
                    src={PORTRAITS[i % PORTRAITS.length]}
                    alt={tst.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                ) : (
                  <div
                    aria-hidden="true"
                    className="w-12 h-12 rounded-full bg-gradient-to-br from-[#1A1A1A] to-[#2a2a2a] text-[#D4AF37] flex items-center justify-center font-display text-base tracking-wide border border-[#D4AF37]/40"
                  >
                    {tst.name.trim().charAt(0).toUpperCase()}
                  </div>
                )}
                <div className="flex-1">
                  <p className="text-sm font-semibold text-[#1A1A1A]">
                    {tst.name}
                  </p>
                  <p className="text-xs text-[#666666] uppercase tracking-widest">
                    {tst.role}
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, k) => (
                    <Star
                      key={k}
                      size={12}
                      className="fill-[#D4AF37] text-[#D4AF37]"
                    />
                  ))}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
